import React, {useEffect} from 'react';
import {Button , makeStyles,Typography}from '@material-ui/core';
import Tables from '../components/DashBoard';
import data from './category';
import CategoryPopupFormik from './AddCategory';
import AuthenticatedPage from "../ContextAndHOC/AuthenticatedPage";
const axios = require("axios").default;
const headCells = [
  { id: 'categoryid', numeric: false, disablePadding: true, label: 'Category Id' },
  { id: 'title', numeric: true, disablePadding: false, label: 'Title' },
  { id: 'image', numeric: true, disablePadding: false, label: 'Image' },
  { id: ' ', numeric: true, disablePadding: false, label: ' ' },
  { id: '', numeric: true, disablePadding: false, label: '' },
];

const useStyles = makeStyles((theme) => ({
 root: {
    maxWidth:'1200px', padding:0, margin:'0 auto'
  },
  title: {flex: '1 1 100%', padding: "34px", paddingLeft:'15px', fontSize: "40px", color: "black", lineHeight: ".78px"},
   button: { height: "40px", margin: "20px 0", marginRight: "20px", backgroundColor: "#2262bf", textColor: "#fff", color: "white",
paddingTop: "7px", paddingRight: "26px", paddingLeft: "13px", paddingBottom: "7px", fontSize: "13.7px", whiteSpace: "nowrap",cursor: "pointer",
 borderRadius: "50px", [theme.breakpoints.down("sm")]: { fontSize: '12px', minWidth: "120px" }, '&:hover': { opacity:'0.8', transition:'0.2s' , backgroundColor:'#2262bf'}
  },
  viewButtonLabel: { padding:'30px', paddingLeft: "36px" },
 }));

 function EnhancedTable() {
   const classes = useStyles();
   const [articletemplate, setArticletemplate] = React.useState();
   const [openpopup, setOpenpopup] = React.useState(false);
   const [open, setOpen] = React.useState(false);
   const [editcategorydata, setEditcategorydata] = React.useState();
   const [close, setClose] = React.useState(0);
   useEffect(() => {
     setArticletemplate(data);
   }, [close]);

   const handleDeleteUser = (categoryid) => {
     const selectedarticle = articletemplate.filter((n) => {
      return n.categoryId !== categoryid;
     });

   };
   const handleEditCategory = (categoryid) => {
     const selectedcategory = articletemplate.filter((n) => {
      return n.categoryid === categoryid;
     });
     setEditcategorydata(selectedcategory);
     setOpen(true);
     setOpenpopup(true);
   };
   const handleAdd = () => {
     setOpen(true);
     setOpenpopup(true);
     setEditcategorydata();
   };
   const handleClose = () => {
     setClose(close + 1);
     setOpen(false);
     setOpenpopup(false);
   };
  return (
    <div className={classes.root}>
      <br /><br /><br />
      <div style={{ display: "flex" }}>
        <Typography className={classes.title} variant="h6" id="tableTitle" component="div"> Category List</Typography>
        {openpopup ? (<CategoryPopupFormik open={open} handleClose={handleClose} editcategorydata={editcategorydata} />) : ("")}
        <Button className={classes.button} onClick={handleAdd} classes={{ label: classes.viewButtonLabel }}> ADD NEW Category</Button>
      </div>
      {articletemplate ? <Tables handleDeleteUser={handleDeleteUser} handleEditTrivia={handleEditCategory} name={"category"} headCells={headCells}
        articletemplate={articletemplate} placeholder={"Search for Category ID …"} /> : ""}
    </div>
  );
}
export default (AuthenticatedPage()(EnhancedTable));